import { makeStyles } from '@mui/styles';

const muiStyles = makeStyles(() => ({
    root: { width: 'fit-content' as const },
    nonSelectableText: { userSelect: 'none' as 'none' },
    copyButtonSmall: {
        cursor: 'pointer' as 'pointer',
        padding: '4px',
        marginLeft: '.4rem'
    },
    copyButtonIcon: {
        height: '14px',
        width: '14px'
    }
}));

export default muiStyles;